import styled from 'styled-components'
import { Alert } from 'antd'

const WrapAlert = styled(Alert)`
  margin-top: 12px;
`

export { WrapAlert }
